/*
THIS FILE IS AUTO-GENERATED, NO MANUAL CHANGES IS ALLOWED
*/

import { isOfErrorType } from '@atlas/shared/data-access/shared';
import axios, { type AxiosError } from 'axios';
import type {
    BadRequestProblemDetailsModel,
    InternalServerErrorProblemDetailsModel,
    NotFoundProblemDetailsModel,
    ServiceUnavailableProblemDetailsModel,
    UnauthorizedProblemDetailsModel
} from '../../models/index';

export type ChatbotConversationsGetErrorModel = AxiosError<
    NotFoundProblemDetailsModel | InternalServerErrorProblemDetailsModel | ServiceUnavailableProblemDetailsModel
>;

export type ChatbotConversationsSummaryGetErrorModel = AxiosError<
    NotFoundProblemDetailsModel | InternalServerErrorProblemDetailsModel | ServiceUnavailableProblemDetailsModel
>;

export type ChatbotConversationsPostErrorModel = AxiosError<
    | BadRequestProblemDetailsModel
    | NotFoundProblemDetailsModel
    | InternalServerErrorProblemDetailsModel
    | ServiceUnavailableProblemDetailsModel
>;

export type ChatbotConversationsRatePostErrorModel = AxiosError<
    | BadRequestProblemDetailsModel
    | NotFoundProblemDetailsModel
    | InternalServerErrorProblemDetailsModel
    | ServiceUnavailableProblemDetailsModel
>;

export type ChatbotConversationsMessagesRatePostErrorModel = AxiosError<
    | BadRequestProblemDetailsModel
    | NotFoundProblemDetailsModel
    | InternalServerErrorProblemDetailsModel
    | ServiceUnavailableProblemDetailsModel
>;

export type ChatbotConversationsInteractionsSummarizePostErrorModel = AxiosError<
    | BadRequestProblemDetailsModel
    | NotFoundProblemDetailsModel
    | InternalServerErrorProblemDetailsModel
    | ServiceUnavailableProblemDetailsModel
>;

export type ChatbotIntegrationsPostErrorModel = AxiosError<UnauthorizedProblemDetailsModel>;

export type ChatbotIntegrationsGetErrorModel = AxiosError<UnauthorizedProblemDetailsModel>;

export class ChatbotServiceErrorGuards {
    static ChatbotConversationsGet = class {
        static isNotFoundProblemDetails = (
            error: ChatbotConversationsGetErrorModel | unknown
        ): error is AxiosError<NotFoundProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<NotFoundProblemDetailsModel>(error, 404);
        };
        static isInternalServerErrorProblemDetails = (
            error: ChatbotConversationsGetErrorModel | unknown
        ): error is AxiosError<InternalServerErrorProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<InternalServerErrorProblemDetailsModel>(error, 500);
        };
        static isServiceUnavailableProblemDetails = (
            error: ChatbotConversationsGetErrorModel | unknown
        ): error is AxiosError<ServiceUnavailableProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ServiceUnavailableProblemDetailsModel>(error, 503);
        };
    };

    static ChatbotConversationsSummaryGet = class {
        static isNotFoundProblemDetails = (
            error: ChatbotConversationsSummaryGetErrorModel | unknown
        ): error is AxiosError<NotFoundProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<NotFoundProblemDetailsModel>(error, 404);
        };
        static isInternalServerErrorProblemDetails = (
            error: ChatbotConversationsSummaryGetErrorModel | unknown
        ): error is AxiosError<InternalServerErrorProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<InternalServerErrorProblemDetailsModel>(error, 500);
        };
        static isServiceUnavailableProblemDetails = (
            error: ChatbotConversationsSummaryGetErrorModel | unknown
        ): error is AxiosError<ServiceUnavailableProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ServiceUnavailableProblemDetailsModel>(error, 503);
        };
    };

    static ChatbotConversationsPost = class {
        static isBadRequestProblemDetails = (
            error: ChatbotConversationsPostErrorModel | unknown
        ): error is AxiosError<BadRequestProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<BadRequestProblemDetailsModel>(error, 400);
        };
        static isNotFoundProblemDetails = (
            error: ChatbotConversationsPostErrorModel | unknown
        ): error is AxiosError<NotFoundProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<NotFoundProblemDetailsModel>(error, 404);
        };
        static isInternalServerErrorProblemDetails = (
            error: ChatbotConversationsPostErrorModel | unknown
        ): error is AxiosError<InternalServerErrorProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<InternalServerErrorProblemDetailsModel>(error, 500);
        };
        static isServiceUnavailableProblemDetails = (
            error: ChatbotConversationsPostErrorModel | unknown
        ): error is AxiosError<ServiceUnavailableProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ServiceUnavailableProblemDetailsModel>(error, 503);
        };
    };

    static ChatbotConversationsRatePost = class {
        static isBadRequestProblemDetails = (
            error: ChatbotConversationsRatePostErrorModel | unknown
        ): error is AxiosError<BadRequestProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<BadRequestProblemDetailsModel>(error, 400);
        };
        static isNotFoundProblemDetails = (
            error: ChatbotConversationsRatePostErrorModel | unknown
        ): error is AxiosError<NotFoundProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<NotFoundProblemDetailsModel>(error, 404);
        };
        static isInternalServerErrorProblemDetails = (
            error: ChatbotConversationsRatePostErrorModel | unknown
        ): error is AxiosError<InternalServerErrorProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<InternalServerErrorProblemDetailsModel>(error, 500);
        };
        static isServiceUnavailableProblemDetails = (
            error: ChatbotConversationsRatePostErrorModel | unknown
        ): error is AxiosError<ServiceUnavailableProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ServiceUnavailableProblemDetailsModel>(error, 503);
        };
    };

    static ChatbotConversationsMessagesRatePost = class {
        static isBadRequestProblemDetails = (
            error: ChatbotConversationsMessagesRatePostErrorModel | unknown
        ): error is AxiosError<BadRequestProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<BadRequestProblemDetailsModel>(error, 400);
        };
        static isNotFoundProblemDetails = (
            error: ChatbotConversationsMessagesRatePostErrorModel | unknown
        ): error is AxiosError<NotFoundProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<NotFoundProblemDetailsModel>(error, 404);
        };
        static isInternalServerErrorProblemDetails = (
            error: ChatbotConversationsMessagesRatePostErrorModel | unknown
        ): error is AxiosError<InternalServerErrorProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<InternalServerErrorProblemDetailsModel>(error, 500);
        };
        static isServiceUnavailableProblemDetails = (
            error: ChatbotConversationsMessagesRatePostErrorModel | unknown
        ): error is AxiosError<ServiceUnavailableProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ServiceUnavailableProblemDetailsModel>(error, 503);
        };
    };

    static ChatbotConversationsInteractionsSummarizePost = class {
        static isBadRequestProblemDetails = (
            error: ChatbotConversationsInteractionsSummarizePostErrorModel | unknown
        ): error is AxiosError<BadRequestProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<BadRequestProblemDetailsModel>(error, 400);
        };
        static isNotFoundProblemDetails = (
            error: ChatbotConversationsInteractionsSummarizePostErrorModel | unknown
        ): error is AxiosError<NotFoundProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<NotFoundProblemDetailsModel>(error, 404);
        };
        static isInternalServerErrorProblemDetails = (
            error: ChatbotConversationsInteractionsSummarizePostErrorModel | unknown
        ): error is AxiosError<InternalServerErrorProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<InternalServerErrorProblemDetailsModel>(error, 500);
        };
        static isServiceUnavailableProblemDetails = (
            error: ChatbotConversationsInteractionsSummarizePostErrorModel | unknown
        ): error is AxiosError<ServiceUnavailableProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ServiceUnavailableProblemDetailsModel>(error, 503);
        };
    };

    static ChatbotIntegrationsPost = class {
        static isUnauthorizedProblemDetails = (
            error: ChatbotIntegrationsPostErrorModel | unknown
        ): error is AxiosError<UnauthorizedProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<UnauthorizedProblemDetailsModel>(error, 401);
        };
    };

    static ChatbotIntegrationsGet = class {
        static isUnauthorizedProblemDetails = (
            error: ChatbotIntegrationsGetErrorModel | unknown
        ): error is AxiosError<UnauthorizedProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<UnauthorizedProblemDetailsModel>(error, 401);
        };
    };
}
